import { useFetchUser } from '@/lib/hooks/useAuth.ts'
import { OrganizationMembership, useUserStore } from '@/store/user.ts'
import { useEffect } from 'react'
import setSentryUser from '@/lib/helpers/sentry/setSentryUser.ts'

export default function useSyncUser() {
  const { data } = useFetchUser()

  const setUser = useUserStore(state => state.setUser)
  const setLoading = useUserStore(state => state.setLoading)
  const setCurrentOrganizationMembership = useUserStore(
    state => state.setCurrentOrganizationMembership,
  )

  useEffect(() => {
    if (data) {
      setSentryUser(data)

      setUser(data)
      setLoading(false)

      if (data.organizationMemberships) {
        const organizationMembership: OrganizationMembership | undefined =
          data.organizationMemberships.find(
            //@ts-expect-error @id exists
            memberShip => memberShip?.['@id'] === data.activeMembership,
          )
        if (organizationMembership) {
          setCurrentOrganizationMembership(organizationMembership)
        } else {
          setCurrentOrganizationMembership(data?.organizationMemberships?.[0])
        }
      }
    }
  }, [data, setCurrentOrganizationMembership, setLoading, setUser])

  return null
}
